import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { SYSTEM_LANGUAGES } from '@/utils/constants/languages';
import { Language } from '@/utils/enums/Languages';

import translationTr from './locales/tr/translation.json';
import translationEn from './locales/en/translation.json';
import translationRu from './locales/ru/translation.json';
import translationAz from './locales/az/translation.json';
import translationKk from './locales/kk/translation.json';
import translationKy from './locales/ky/translation.json';
import translationUz from './locales/uz/translation.json';

const resources = {
  tr: {
    translation: translationTr,
  },
  en: {
    translation: translationEn,
  },
  ru: {
    translation: translationRu,
  },
  az: {
    translation: translationAz,
  },
  kk: {
    translation: translationKk,
  },
  ky: {
    translation: translationKy,
  },
  uz: {
    translation: translationUz,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SYSTEM_LANGUAGES,
    fallbackLng: Language.Turkish,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
